import { NavLink, useLocation } from 'react-router';
import logoDark from '../assets/logo-horizontal-branco.svg';
import logo from '../assets/logo-horizontal-cor.svg';
import { useLogoSrc } from '../lib/brand-api';
import { navCount, useNavCounts } from '../lib/data-api';
import icon from '../assets/icone-cor-quadrado.svg';
import { NAV, SETTINGS } from '../nav';
import { ROLE_LABELS, initials, useMe } from '../lib/session';
import { useTheme } from '../lib/theme';
import { Icon } from './Icon';

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? 'navi on' : 'navi');

/** design/Sidebar.dc.html */
export function Sidebar({ mini, onToggleMini }: { mini: boolean; onToggleMini: () => void }) {
  const { dz, dark } = useTheme();
  const me = useMe();
  const { pathname } = useLocation();
  const inSettings = pathname.startsWith('/configuracoes');

  const logoSrc = useLogoSrc(dark ? logoDark : logo);
  const counts = useNavCounts();
  return (
    <nav className={`${dz} sb${mini ? ' mini' : ''}`} aria-label="Menu principal">
      <div className="brand">
        {mini ? (
          <img
            src={icon}
            alt="Deizi3d"
            style={{ width: 40, height: 40, borderRadius: 10, display: 'block' }}
          />
        ) : (
          <img
            src={logoSrc}
            alt="Deizi3d"
            style={{ width: 148, height: 'auto', display: 'block' }}
          />
        )}
      </div>
      <div className="nav">
        {NAV.map((group) => (
          <div key={group.label ?? 'home'} style={{ display: 'contents' }}>
            {group.label ? (
              <>
                <div className="navgrp">{group.label}</div>
                <div className="navsep" />
              </>
            ) : null}
            {group.items.map((item) => (
              <NavLink
                key={item.key}
                to={item.to}
                end={item.to === '/'}
                className={navClass}
                aria-label={mini ? item.label : undefined}
                title={mini ? item.label : undefined}
              >
                <Icon name={item.icon} />
                <span className="lb">{item.label}</span>
                {navCount(counts.data, item.key) ? (
                  <span
                    className="count"
                    aria-label={`${navCount(counts.data, item.key)} pendentes`}
                  >
                    {navCount(counts.data, item.key)}
                  </span>
                ) : null}
              </NavLink>
            ))}
          </div>
        ))}
        <div className="navsep" />
        <NavLink
          to="/configuracoes"
          className={() => (inSettings && mini ? 'navi on' : 'navi')}
          style={{ marginTop: 10 }}
          aria-label={mini ? 'Configurações' : undefined}
          title={mini ? 'Configurações' : undefined}
        >
          <Icon name="gear" />
          <span className="lb">Configurações</span>
        </NavLink>
        {inSettings && !mini ? (
          <div
            className="full"
            style={{ display: 'flex', flexDirection: 'column', gap: 2, paddingLeft: 32 }}
          >
            {SETTINGS.map((item) => (
              <NavLink
                key={item.key}
                to={item.to}
                className={navClass}
                style={{ height: 36, fontSize: 14 }}
              >
                {item.label}
              </NavLink>
            ))}
          </div>
        ) : null}
      </div>
      <div className="foot">
        <span className={dark ? 'avatar co' : 'avatar'}>{initials(me.name)}</span>
        <div
          className="lb"
          style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2, minWidth: 0 }}
        >
          <span style={{ fontWeight: 500 }}>{me.name}</span>
          <span className="xs muted">{ROLE_LABELS[me.role]}</span>
        </div>
        <button
          type="button"
          className="btn icon g sm"
          onClick={onToggleMini}
          aria-label={mini ? 'Expandir menu' : 'Recolher menu'}
          title={mini ? 'Expandir menu' : 'Recolher menu'}
          style={mini ? { transform: 'rotate(180deg)' } : undefined}
        >
          <Icon name="chevronsLeft" />
        </button>
      </div>
    </nav>
  );
}
